import { RouterManager } from '@aclass/admin/managers';
import { RedirectStory } from '@aclass/admin/storage/actions';
import { IAdminState, IRedirectModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class RedirectSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:redirect-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IRedirectModuleState['searchPageInitialized']>(['redirectModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(RedirectSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(RedirectStory.dryRunSearchPage());
    }
}
